module.exports = __webpack_public_path__ + "img/web-designer-banner-test.5d6898bb.jpg";